import { actionTree } from 'typed-vuex';
import { LoginPayload } from '@/store/modules/auth/types';
import factory from '@/repositories/fo-manual-API/RepositoryFactory';
import initialState from './state';
import getters from './getters';
import mutations from './mutations';

const authRepository = factory.get('auth');

export default actionTree(
  { state: initialState, getters, mutations },
  {
    async login({ commit }, { email, password }: LoginPayload) {
      try {
        const res = await authRepository.login(email, password);
        commit('AUTH_SUCCESS', res.data);
      } catch (err) {
        commit('LOGOUT_CLEAR_STATE');
      }
    },

    logout({ commit }) {
      commit('LOGOUT_CLEAR_STATE');
    },
  },
);
